import 'core-js'
import 'react-app-polyfill/ie11'
import React from 'react'
import ReactDOM from 'react-dom'
import SharedDashboardEntry from 'pages/sharedDashboard/SharedDashboardEntry'
import { isSharedDashboardEntry } from 'utils/dashboardSharing'

// Even module evaluation may read saved credentials or initialize SDKs. Load the
// authenticated application only after the anonymous mode resolver requires it.
const ApplicationEntry = React.lazy(() => import('core/ApplicationEntry'))
const authenticatedApp = (
  <React.Suspense fallback={<div role='status'>Loading…</div>}>
    <ApplicationEntry />
  </React.Suspense>
)

ReactDOM.render(
  <React.StrictMode>
    {isSharedDashboardEntry(window.location.pathname) ? (
      <SharedDashboardEntry restrictedApp={authenticatedApp} />
    ) : (
      authenticatedApp
    )}
  </React.StrictMode>,
  document.getElementById('root'),
)
